import { FormBuilder, FormGroup } from '@angular/forms';

export class CodeDescriptionModel {
    code: string = null;
    description: string = null;
    shortName: string = null;

    constructor(model?: Partial<CodeDescriptionModel>) {
        if (model && model !== undefined) {
          const def = new CodeDescriptionModel();
          Object.keys(def).forEach((key: string) => {
            this[key] = model[key] !== null && model[key] !== undefined ?
              model[key] : def[key];
          });
        }
      }

    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            code: [],
            description: [],
            shortName: []
        });
    }

    static generateForm(fb: FormBuilder, model: CodeDescriptionModel): FormGroup {
        const form = CodeDescriptionModel.asForm(fb);
        form.setValue(model);
        return form;
    }

    static convertFormToModel(form: FormGroup): CodeDescriptionModel {
        return form.value;
    }
}
